/**
 * La lecture du règlement des inscriptions affichées.
 *
 * `reglement_des_inscriptions` est réservée à l'administration et à la
 * coordination, et refuse plus de 1 000 inscriptions par appel ; on en
 * envoie 500 à la fois. Elle ne rend que la facture et son état, aucun
 * montant.
 */
import { db } from '../payments/db';
import type { Settlement } from '../factures/types';
import type { LigneDeReglement } from './reglement';

const INSCRIPTIONS_PAR_APPEL = 500;

interface LigneLue {
  registration_id: string;
  invoice_number: string;
  settlement: string;
}

/**
 * Les factures de chaque inscription, par identifiant. Une inscription
 * absente de la carte n'a pas de facture.
 */
export async function lireReglementDesInscriptions(
  registrationIds: readonly string[],
): Promise<Map<string, LigneDeReglement[]>> {
  const parInscription = new Map<string, LigneDeReglement[]>();

  for (let i = 0; i < registrationIds.length; i += INSCRIPTIONS_PAR_APPEL) {
    const paquet = registrationIds.slice(i, i + INSCRIPTIONS_PAR_APPEL);
    const { data, error } = await db.rpc('reglement_des_inscriptions', { p_inscriptions: paquet });
    if (error) throw error;

    for (const l of (data ?? []) as LigneLue[]) {
      const lignes = parInscription.get(l.registration_id) ?? [];
      lignes.push({
        registrationId: l.registration_id,
        invoiceNumber: l.invoice_number,
        settlement: l.settlement as Settlement,
      });
      parInscription.set(l.registration_id, lignes);
    }
  }

  return parInscription;
}
